import { auth } from ".";
import Parse from "./parse.service";

const OnboardingClass = Parse.Object.extend("Onboarding");
const Kyc = Parse.Object.extend("Kyc");
const User = Parse.Object.extend("User");

export const getKycIdByUserId = async (userId = null) => {
    const user = userId ? new Parse.User({ id: userId }) : auth.fetchUser();
    const query = new Parse.Query(OnboardingClass);
    query.equalTo("userId", user);
    query.select("kycId");
    const onboarding = await query.first();
    return onboarding?.get("kycId")?.id;
}

export const getUserBasic = async (userId = null) => {
    const kycId = await getKycIdByUserId(userId);
    if (!kycId) return;
    const query = new Parse.Query(Kyc);
    query.select("basic");
    const kyc = await query.get(kycId);
    return kyc?.get("basic");
}

export const getUserByUserId = async (userId) => {
    if (!userId) return;
    try {
        const query = new Parse.Query(User);
        query.select("username");
        const user = await query.get(userId);
        return user;
    } catch (error) {
        console.error(error);
    }
}

//method to update user details
export const updateUserBasic = async (data) => {
    const kycId = await getKycIdByUserId();
    if (!kycId) return;
    const query = new Parse.Query(Kyc);
    const kyc = await query.get(kycId);

    kyc.set("basic", {
        ...kyc?.get("basic"),
        ...data
    });

    const res = await kyc.save();
    return res?.get("basic")
}